import React, { useState, useEffect } from 'react'

import CountInputRow from './CountInputRow/CountInputRow'

const PlusMinusOptions = ({
  optionData,
  allSelectedOptions,
  setAllSelectedOptions,
  setRequireCheckArr,
  currency
}) => {
  const [optionSettings, setOptionSettings] = useState([])

  const [totalCount, setTotalCount] = useState(0)

  useEffect(() => {
    const valuesWithQuantities = optionSettings.reduce((acc, curr) => {
      if (curr.quantity) {
        acc.push(curr)
      }

      return acc
    }, [])

    if (valuesWithQuantities.length) {
      setAllSelectedOptions([
        ...allSelectedOptions.filter(
          (option) => option.optionName !== optionData.name
        ),
        {
          optionName: optionData.name,
          optionSet: valuesWithQuantities
        }
      ])
    } else {
      setAllSelectedOptions([
        ...allSelectedOptions.filter(
          (option) => option.optionName !== optionData.name
        )
      ])
    }
  }, [optionSettings])

  useEffect(() => {
    setRequireCheckArr((requireCheckArr) => [
      ...requireCheckArr.filter(
        (checkValue) => checkValue.id !== optionData.id
      ),
      {
        id: optionData.id,
        decent: true
      }
    ])
  }, [])

  const onChangeCallback = (incomingValue, quantity) => {
    const foundValue = optionSettings?.find(
      (value) => value.itemName === incomingValue.name
    )

    if (foundValue) {
      setOptionSettings([
        ...optionSettings.filter(
          (value) => value.itemName !== incomingValue.name
        ),
        {
          id: incomingValue.id,
          itemName: incomingValue.name,
          additionalCost: incomingValue.cost,
          quantity
        }
      ])
    } else {
      setOptionSettings([
        ...optionSettings,
        {
          id: incomingValue.id,
          itemName: incomingValue.name,
          additionalCost: incomingValue.cost,
          quantity
        }
      ])
    }
  }

  return (
    <div>
      {optionData.values.map((value) => (
        <CountInputRow
          value={value}
          disabled={totalCount === optionData.max_select}
          setTotalCount={setTotalCount}
          totalCount={totalCount}
          onChangeCallback={onChangeCallback}
          currency={currency}
        />
      ))}
    </div>
  )
}

export default PlusMinusOptions
